import { ApiClient } from '../ApiClient';

/**
 * API class for Bond Arb Operator Console endpoints.
 * All endpoints live under /arb/* on the LP Bonds API server.
 */
export class ArbConsoleApi {
  /**
   * @param {module:ApiClient} [apiClient] Optional API client, defaults to lpBondsApiInstance.
   */
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.arbApiInstance;
  }

  /**
   * GET /arb/routes
   * List scanned arb routes with optional filters.
   * @param {Object} params
   * @param {string} [params.chain] Filter by chain name
   * @param {number} [params.minProfit] Minimum profit percentage
   * @param {string} [params.readiness] Filter by readiness status (Ready|Partial|Not ready)
   */
  async getRoutes({ chain, minProfit, readiness } = {}) {
    const queryParams = {};
    if (chain) {
      queryParams.chain = chain;
    }
    if (minProfit !== undefined) {
      queryParams.minProfit = minProfit;
    }
    if (readiness) {
      queryParams.readiness = readiness;
    }

    return await this.apiClient.callApi('/arb/routes', 'get', {}, queryParams);
  }

  /**
   * GET /arb/routes/executable
   * List only routes that pass all gates (profit + depth + readiness).
   */
  async getExecutableRoutes() {
    return await this.apiClient.callApi('/arb/routes/executable', 'get', {}, {});
  }

  /**
   * GET /arb/routes/:id
   * Get a single route by ID.
   * @param {string} id Route ID
   */
  async getRouteById(id) {
    return await this.apiClient.callApi('/arb/routes/{id}', 'get', { id }, {});
  }

  /**
   * GET /arb/status
   * Get scanner health and metadata.
   */
  async getStatus() {
    return await this.apiClient.callApi('/arb/status', 'get', {}, {});
  }

  /**
   * GET /arb/balances
   * Get bot wallet inventory across all chains.
   */
  async getBalances() {
    return await this.apiClient.callApi('/arb/balances', 'get', {}, {});
  }

  /**
   * GET /arb/executions
   * Get execution history log.
   */
  async getExecutions() {
    return await this.apiClient.callApi('/arb/executions', 'get', {}, {});
  }
}
